<template>
  <div class="bk-list-box">
    <Header pageTitle="选刊投稿" />
    <van-list v-model="loading" :finished="finished" :error="error" :offset="20"
      :finished-text="list.length > 0 ? '加载完毕' : ''" error-text="请求失败，点击重新加载" @load="onLoad">
      <div class="bk-list" v-if="loading || list.length > 0">
        <BkItem class="bk-list-item" v-for="item in list" :key="item.id" :cover="item.coverImg" :name="item.name"
          @click.native="toDetail(item.id)" />
      </div>
      <noneList noneType="bkList" v-else />
    </van-list>
    <van-popup v-model="linkShow" round position="bottom" class="link_popup">
      <h3 class="link_h3">暂不支持手机投稿，去网页投稿</h3>
      <p class="link_p">1. 用电脑访问</p>
      <p class="link_p link_text">{{ link }}</p>
      <p class="link_p">2. 使用手机/账号登录后即可开始投稿</p>
      <div class="link_btn_box">
        <van-button class="link_btn" round type="default" @click="clearPopup()">知道了</van-button>
        <van-button class="link_btn" round type="info" @click="toCopy()">复制链接</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Header from "@/views/mobileView/components/header";
import BkItem from "@/views/mobileView/components/listItem/bkItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
import { Toast } from "vant";
export default {
  components: {
    Header,
    BkItem,
    noneList
  },
  data() {
    return {
      params: {
        beginDateTime: Date.now(),
        pageNo: 0,
        pageSize: 15,
      },
      list: [],
      loading: false,
      finished: false,
      error: false,
      linkShow: false,
      link: "",
    }
  },
  methods: {
    // 触底加载
    onLoad() {
      this.params.pageNo += 1;
      this.getList();
    },
    // 获取列表
    async getList() {
      this.loading = true;
      try {
        const { data } = await this.$apis.listServe.getManuscriptList(this.params);
        this.finished = data.list.length < 15;
        this.list.push(...data.list);
      } catch (error) {
        this.error = true;
      }
      this.loading = false;
    },
    // 点击进入详情页
    toDetail(id) {
      this.linkShow = true
      this.link = `${this.$global.tsgUrl}?prid=${id}#/manage/author`
    },
    // 关闭弹窗
    clearPopup() {
      this.linkShow = false
      this.link = ""
    },
    // 复制链接
    toCopy() {
      const input = document.createElement("input");
      input.setAttribute("readonly", "readonly");
      input.setAttribute("value", this.link);
      document.body.appendChild(input);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        Toast("链接已复制");
        this.clearPopup()
      }
      document.body.removeChild(input);
    },
  },
}
</script>

<style scoped lang="scss">
.bk-list-box {
  padding-top: 44px;
  min-height: 100vh;
  background-color: #f5f5f5;
  overflow: hidden;

  .bk-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 12px auto;
    padding: 14px 12px 0;
    width: 351px;
    background-color: #fff;
    border-radius: 8px;

    .bk-list-item {
      margin-bottom: 20px;
      width: 99px;
    }

    &::after {
      content: "";
      width: 99px;
    }
  }

  .link_popup {
    padding: 24px 25px;

    .link_h3 {
      margin-bottom: 25px;
      font-size: 17px;
      color: #333333;
      line-height: 18px;
    }

    .link_p {
      font-size: 14px;
      color: #333333;
      line-height: 23px;
    }

    .link_text {
      margin: 12px 0 21px;
    }

    .link_btn_box {
      display: flex;
      justify-content: space-between;
      margin-top: 25px;

      .link_btn {
        width: 155px;
        height: 40px;
        border-radius: 20px;
      }
    }
  }
}
</style>